<template>
  <div class="pa-3">
    <div class="d-flex">
      <h3>Asset Classes</h3>
      <v-spacer />
      <v-btn color="primary" flat @click="createAssetClass">
        <v-icon class="mr-1">mdi-plus</v-icon>Asset Class
      </v-btn>
    </div>
    <div
      v-for="assetClass in assetClasses"
      :key="assetClass.id"
      class="d-flex align-center mt-2"
    >
      <v-row no-gutters>
        <v-col cols="3">
          <v-text-field
            v-model="assetClass.name"
            label="Name"
            variant="outlined"
            density="compact"
            hide-details
            @update:focused="!$event && assetClass.save()"
          />
        </v-col>
      </v-row>
      <v-btn
        class="ml-2"
        icon="mdi-delete"
        flat
        density="compact"
        @click="deleteAssetClass(assetClass)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { AssetClass } from "@/classes";
import { useConfirmStore } from "@/store/confirm";
import { useListStore } from "@/store/lists";
import { onMounted, onUnmounted, ref } from "vue";

const $confirm = useConfirmStore();
const lists = useListStore();

const assetClasses = ref<AssetClass[]>([]);
onMounted(async () => {
  assetClasses.value = await AssetClass.list();
  assetClasses.value.sort((a, b) => a.created.getTime() - b.created.getTime());
});
onUnmounted(() => {
  lists.refreshList("assetClasses");
});

const createAssetClass = async () => {
  const newAssetClass = new AssetClass();
  await newAssetClass.save();
  assetClasses.value.push(newAssetClass);
};

const deleteAssetClass = async (assetClass: AssetClass) => {
  $confirm.open({
    onConfirm: async () => {
      assetClasses.value = assetClasses.value.filter(
        (ac) => ac.id !== assetClass.id,
      );
      await assetClass.deleteObject();
    },
  });
};
</script>
